"use strict";

import "./UserContacts.css";

import React from "react";
import ReactDOM from "react-dom";

import classnames from "classnames";
import countryCodes from "vfu/countryCodes";
import pattern from "vfu/pattern";
import lang from "vwa/lang";
import Button from "vwa/components/Button";
import Form from "vwa/components/Form";
import Input from "vwa/components/Input";
import Select from "vwa/components/Select";
import ProgressBar from "vwa/components/ProgressBar";
import Toast from "vwa/components/Toast";
import Card from "vwa/components/Card";

import sessionStore from "./../../store/session";
import {getContacts} from "./../../utils/user";
import saveContacts from "./../../api/saveContacts";

export default class UserContacts extends React.Component {

	constructor(props){
		super(props);
		this.initState();
		this.setStoreListeners();
	}
	
	initState(){
		this.state = {
			inProgress: false,
			email: "",
			phone: {
				countryCode: "",
				number: ""
			},
			valid: false
		};
	}
	
	setStoreListeners() {
		sessionStore.on("change", _ => this.setStateFromStore())
	}
	
	componentDidMount() {
		this.setStateFromStore();
		this.setEmailValidity();
	}
	
	setStateFromStore() {
		const contacts = getContacts();
		this.setState({
			email: this.getEmailFromContacts(contacts),
			phone: this.getPhoneFromContacts(contacts)
		});
	}
	
	getEmailFromContacts(contacts) {
		const emailContact = contacts.find(contact => contact.type == "Email");
		return emailContact ? emailContact.email : "";
	}
	
	getPhoneFromContacts(contacts) {
		const {countryCode = "", number = ""} = contacts.find(contact => contact.type == "Phone") || {};
		return {countryCode, number: formatPhoneNumber(number)};
	}
	
	getContactsFromState() {
		const contacts = [];
		if (this.state.email)
			contacts.push({type: "Email", email: this.state.email});
		if (this.state.phone.number)
			contacts.push({type: "Phone", countryCode: this.state.phone.countryCode, number: this.state.phone.number});
		return contacts;
	}
	
	setEmailValidity() {
		const emailInput = ReactDOM.findDOMNode(this.refs.email);
		this.setState({
			valid: emailInput.validity.valid
		});
	}
	
	handleEmailChange(email) {
		this.setEmailValidity();
		this.setState({email});
	}
	
	handlePhoneChange(countryCode = null, number = null) {
		this.setState({
			phone: {
				countryCode: countryCode !== null ? countryCode : this.state.phone.countryCode,
				number: formatPhoneNumber(number !== null ? number : this.state.phone.number)
			}
		});
	}
	
	handleSave() {
		this.save();
	}
	
	async save() {
		const contacts = this.getContactsFromState();
		this.setState({inProgress: true});
		try {
			await saveContacts(contacts);
			this.hide();
		} catch (error) {
			this.setState({
				errorMessage: error.message
			});
		}
		this.setState({inProgress: false});
	}
	
	getSaveButtonDisabled() {
		return this.state.inProgress || !this.state.valid;
	}
	
	renderSelect(countryCode) {
		return (
			<Select
				defaultValue={countryCode}
				value={this.state.phone.countryCode}
				onChange={evt => this.handlePhoneChange(evt.target.value, null)}
			>
				<option key="" value={null}></option>
				{countryCodes.map(cc =>
					<option key={cc} value={cc}>{cc}</option>
				)}
			</Select>
		);
	}
	
	render(){
		return(
			<div className="UserContacts">
				<header className="Shadowed">
					<Button className="Red" disabled={this.getSaveButtonDisabled()} onClick={_ => this.handleSave()}>{lang.SAVE}</Button>
				</header>
				<div className="Content">
					<ProgressBar indeterminate shown={this.state.inProgress} />
					<Card className={this.state.inProgress ? "Hidden" : null}>
						<Form>
							<label>{lang.EMAIL}</label>
							<Input ref="email" value={this.state.email} onChange={evt => this.handleEmailChange(evt.target.value)} pattern={pattern.EMAIL.source}/>
							<label>{lang.PHONE}</label>
							<div className="PhoneContainer">
								<span>+</span>
								{this.renderSelect()}
								<Input value={this.state.phone.number} onChange={evt => this.handlePhoneChange(null, evt.target.value)} />
							</div>
						</Form>
					</Card>
				</div>
			</div>
		);
	}

}

UserContacts.propTypes = {
	contacts:	React.PropTypes.arrayOf(
					React.PropTypes.oneOfType([
						React.PropTypes.shape({
							type: React.PropTypes.string,
							email: React.PropTypes.string
						}),
						React.PropTypes.shape({
							type: React.PropTypes.string,
							countryCode: React.PropTypes.string,
							number: React.PropTypes.string
						}),
					])
				)
};

UserContacts.defaultProps = {
	contacts: []
};

function formatPhoneNumber(number) {
	return number.replace(/[\s\D]+/g, '');
}


// WEBPACK FOOTER //
// ./src/view/UserContacts/UserContacts.jsx